import { Box, CircularProgress } from "@mui/material";

export default function LoadingView(props) {
    return <Box style={{ flexGrow: 2, marginBlock: "0.5em", marginInline: "1em", paddingBlock: "0.5em", paddingInline: "1em", display: "flex", flexDirection: "row", justifyItems: "center", alignItems: "center", borderRadius: "0.5em" }} >
        <CircularProgress sx={{ color: "grey", margin: "auto" }} size={20} />
    </Box>
}